import { render, staticRenderFns } from "./CPaymentDetail.vue?vue&type=template&id=d5071176&"
import script from "./CPaymentDetail.vue?vue&type=script&lang=js&"
export * from "./CPaymentDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports